<template>
  <b-dropdown
    size="xl"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
  >
    <template v-slot:button-content>
      <font-awesome-icon
        :icon="['fas', 'plus-circle']"
        class="text-primary"
        style="cursor: pointer;"
      />
      <span class="sr-only"> {{ $t('treatments.searchDropdown') }} </span>
    </template>

    <div class="p-2 mr-3">
      <input
        class="form-control"
        v-model="tagSearch"
        :placeholder="`Pesquisar ${mainTagId ? 'subcategorias' : 'categorias'}`"
      />
    </div>

    <b-list-group v-if="!mainTagId && options.length !== 0">
      <b-dropdown-text>
        <b-list-group-item
          style="padding: 6px; margin-bottom: 3px; border: none;"
          v-for="(option, i) in tagsList"
          :key="i"
          :value="option._id"
          @click="handleTagClick(option)"
          :active="myAnswer.tags.findIndex((el) => el._id === option._id) >= 0"
        >
          {{ option.name }}
        </b-list-group-item>
      </b-dropdown-text>
    </b-list-group>

    <b-list-group v-if="mainTagId && subTags.length !== 0">
      <b-dropdown-text>
        <b-list-group-item
          style="padding: 6px; margin-bottom: 3px; border: none;"
          v-for="(subtag, i) in subTags"
          :key="i"
          :value="subtag._id"
          @click="handleSubTagClick(subtag)"
          :active="
            myAnswer.subTags.findIndex((el) => el._id === subtag._id) >= 0
          "
        >
          {{ subtag.name }}
        </b-list-group-item>
      </b-dropdown-text>
    </b-list-group>
  </b-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../services/api';

export default {
  props: {
    idItem: { type: String },
    tags: { type: Array },
    tagGroupId: { type: String },
    myAnswer: { type: Object },
    mainTagId: { type: String },
  },

  data: () => ({
    userAuth: null,
    tagSearch: '',
    answerTags: [],
    subTags: [],
    options: [],
    loading: false,
  }),

  computed: {
    ...mapState('treatments', ['answer', 'oneAnswer']),

    tagsList() {
      return this.options.filter((option) => {
        return option.name.toLowerCase().includes(this.tagSearch.toLowerCase());
      });
    },
  },

  methods: {
    async handleSubTagClick(subTag) {
      let operation = null;

      const subTagIndex = this.myAnswer.subTags.findIndex(
        (el) => el._id === subTag._id,
      );

      if (subTagIndex >= 0) {
        operation = 'delete';
      } else {
        operation = 'add';
      }

      if (subTagIndex >= 0) {
        this.myAnswer.subTags.splice(subTagIndex, 1);
      } else {
        this.myAnswer.subTags.push(subTag);
      }

      this.loadingSub = true;

      await api.patch(
        `/tag-subtag/${this.myAnswer._id}`,
        {
          subTagId: subTag._id,
          tagId: this.mainTagId,
          operation,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.loadingSub = false;
    },

    async handleTagClick(tag) {
      const foundIndex = this.myAnswer.tags.findIndex(
        (el) => el._id === tag._id,
      );

      if (foundIndex >= 0) {
        this.myAnswer.tags.splice(foundIndex, 1);
        const response = await api.patch(
          `/answer-tags/${this.myAnswer._id}`,
          {
            operation: 'delete',
            tagId: tag._id,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        this.myAnswer.subTags = response.data.subTags;
      } else {
        this.myAnswer.tags.push(tag);

        await api.patch(
          `/answer-tags/${this.myAnswer._id}`,
          {
            operation: 'add',
            tagId: tag._id,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      }
    },

    async showSubTags() {
      this.loadingSub = true;

      const response = await api.get(`/config-subtags/${this.mainTagId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.subTags = response.data;

      this.loadingSub = false;
    },

    async getAnswerTag() {
      try {
        const response = await api.get('/tags-dropdown', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            tagGroup: this.tagGroupId,
          },
        });

        this.answerTags = response.data;
        this.options = this.answerTags;

        this.options.forEach((element) => {
          element.displaySubTags = false;
          element.subTags = [];
          element.loading = false;
        });
      } catch (error) {
        window.console.log(error);
      }
    },
  },

  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.getAnswerTag();
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if (this.mainTagId) {
      this.showSubTags();
    }
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu li {
  width: 380px !important;
  margin-bottom: 10px;
}

.b-dropdown-text {
  padding: 8px !important;
}

.icon-eraser-category {
  margin-left: -5px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 5px;
}

.input-search-categories {
  width: 70%;
  margin-top: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-left: 20px;
}

ul div {
  max-height: 250px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/add-treatment-tags/index.vue